import { render, staticRenderFns } from "./JdhStructuralButton.vue?vue&type=template&id=edade16e&scoped=true&"
import script from "./JdhStructuralButton.vue?vue&type=script&lang=ts&"
export * from "./JdhStructuralButton.vue?vue&type=script&lang=ts&"
import style0 from "./JdhStructuralButton.vue?vue&type=style&index=0&id=edade16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edade16e",
  null
  
)

export default component.exports